import React from "react";


export const BottomPage = () => (
  <div className="align-link" id="align-link">
    <small className="italic"> </small>
    <footer> 
    <a
      href="https://github.com/samanthaoria/weather-react.git"
      className="link-git italic bold"
      target="_blank"
    >
      Open-source code 
    </a>
    <span className="name-after-git bold"> by Samantha Oriá</span>
    </footer>
    
  </div>
);


